module.exports = __webpack_public_path__ + "static/media/CardCaldasNovas1.bd25d00c.jpg";